"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
var Link = function (_a) {
    var reasonCode = _a.reasonCode;
    var _b = (0, core_1.useComponents)(), P = _b.P, TextLink = _b.TextLink;
    var _c = (0, core_1.useLinks)(), meterReads = _c.meterReads, setupDirectDebit = _c.setupDirectDebit /* , payments */;
    var _d = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _d.copy, Copy = _d.Copy;
    switch (reasonCode) {
        case 'StaleMeterReadingError':
        case 'NO_FRESH_METER_READING':
            return (react_1.default.createElement(P, null,
                react_1.default.createElement(TextLink, { href: meterReads() }, copy('staleMeterReadingLinkDescription'))));
        case 'NoDirectDebitError':
        case 'NO_ACTIVE_MANDATE':
            return (react_1.default.createElement(P, null,
                react_1.default.createElement(TextLink, { href: setupDirectDebit() }, copy('noDDLinkDescription'))));
        default:
            return react_1.default.createElement(Copy, { copyKey: "paymentsBackLink" });
    }
};
exports.Link = Link;
